import moment from 'moment';
import { fromUtcToLocalMoment } from '../utilities/DateHelpers';
import { MomentTimeFormat } from '../MomentTimeFormat';

const getCrewOverrideStartTimeValue = (
    overrideStartTimes,
    idKey,
    resourceId
) => {
    const override = (overrideStartTimes || []).find(
        (item) => item[idKey] == resourceId
    );

    return override?.startTime
        ? fromUtcToLocalMoment(override.startTime).format(
              MomentTimeFormat.AnteTwelveHour
          )
        : null;
};

export const getPersistedCrewOverrideStartTime = (
    jobResourceOverrides,
    idKey,
    resourceId
) => {
    const intendedIdKey =
        idKey === 'employeeId' ? 'intendedEmployeeId' : 'intendedEquipmentId';

    return getCrewOverrideStartTimeValue(
        jobResourceOverrides,
        intendedIdKey,
        resourceId
    );
};

export const getDisplayedCrewOverrideStartTime = (
    job,
    jobResourceOverrides,
    overrideKey,
    idKey,
    resourceId
) =>
    getCrewOverrideStartTimeValue(job?.[overrideKey], idKey, resourceId) ||
    getPersistedCrewOverrideStartTime(jobResourceOverrides, idKey, resourceId);

export const hasPersistedCrewOverrides = (jobResourceOverrides, idKey) => {
    const intendedIdKey =
        idKey === 'employeeId' ? 'intendedEmployeeId' : 'intendedEquipmentId';

    return (jobResourceOverrides || []).some(
        (override) => override[intendedIdKey]
    );
};

export const buildCrewOverrideStartTime = (job, timeValue) => {
    const parsedTime = moment(timeValue, 'HH:mm', true);

    if (!parsedTime.isValid()) {
        return null;
    }

    const baseDate = moment(job?.weekOfDate || job?.startTime);
    const date = baseDate.isValid() ? baseDate : moment();

    return date
        .clone()
        .hour(parsedTime.hour())
        .minute(parsedTime.minute())
        .second(0)
        .millisecond(0)
        .toDate();
};

export const updateCrewOverrideStartTimes = (
    job,
    onCrewComponentsChanged,
    overrideKey,
    idKey,
    resourceId,
    value
) => {
    const currentOverrides = job?.[overrideKey] || [];
    const updatedOverrides = currentOverrides.filter(
        (item) => item[idKey] != resourceId
    );

    if (value) {
        updatedOverrides.push({
            [idKey]: resourceId,
            startTime: buildCrewOverrideStartTime(job, value),
        });
    }

    onCrewComponentsChanged(
        job?.crewEmployeeMemberships || [],
        job?.crewEquipmentMemberships || [],
        overrideKey === 'employeeOverrideStartTimes' ? updatedOverrides : null,
        overrideKey === 'equipmentOverrideStartTimes' ? updatedOverrides : null
    );
};
